/**
 * Routes for the legacy API Examples page. Mirrors api-credentials/routes.tsx: when the
 * `developerTools` flag is on, the API Explorer tab replaces this page and the legacy
 * `/dashboard/api-examples` path redirects there (keeping old links working); when off, the legacy
 * ApiExamplesView still renders.
 */
import { Navigate, RouteObject } from "react-router-dom";
import { routePaths, withHandle } from "../utils/route.util";
import { ApiExamplesView } from "./ApiExamplesView";

export const apiExamplesRoutes: RouteObject[] = [
  {
    path: "api-examples",
    element: <ApiExamplesView />,
    ...withHandle("api-examples"),
  },
];

export const apiExamplesRedirectRoutes: RouteObject[] = [
  {
    path: "api-examples",
    element: <Navigate to={routePaths["developer-tools:api-explorer"]} replace />,
    ...withHandle("api-examples-redirect"),
  },
];
